import Configuracao from '../misc/Configuracao';
import type { Processo } from '../modelo';
import { PeticaoPendente } from '../modelo/PeticaoApreciada';
import fetch from './AxiosAdapter';

export interface ProcessoPeticoesPendentesDto extends Partial<Processo> {
    identificadorProcesso: number;
    numeroProcesso: string;
    peticoesPendentes: PeticaoPendente[];
}

class EscaninhoPeticaoApi {
    async buscarPeticoesPendentes(gabinete: string, idsProcessos: number[], abortSignal: AbortSignal): Promise<ProcessoPeticoesPendentesDto[]> {
        const result = await fetch<ProcessoPeticoesPendentesDto[]>(Configuracao.urlProcGabPeticao.replace('{SIGLA_GABINETE}', gabinete), {
            method: 'POST',
            body: idsProcessos,
            signal: abortSignal,
            timeout: 120000
        });
        return result.data;
    }

    async buscarPeticoesPendentesPorProcesso(idProcesso: number): Promise<Map<number, PeticaoPendente[]>> {
        const result = await fetch<Map<number, PeticaoPendente[]>>(Configuracao.urlProcGabPeticaoPorProcesso.replace('{ID_PROCESSO}', idProcesso.toString()));
        return result.data;
    }
}

export default new EscaninhoPeticaoApi();
